import React from "react";

export const PreSetTheme = () => (
  <script
    dangerouslySetInnerHTML={{
      __html: `
      (function() {
        function getInitialMode() {
          const stored = window.localStorage.getItem('color-mode');
          if (stored && (stored === "light" || stored === "dark")) {
            return stored;
          }
          const mql = window.matchMedia('(prefers-color-scheme: light)');
          return mql.matches ? 'light' : 'dark';
        }
    
        const mode = getInitialMode();
        localStorage.setItem('color-mode', mode);
      })();
    `
    }}
  />
);
